var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('div',{staticClass:"grid"},[_c('img',{attrs:{"src":_vm.gridImg,"alt":""}})]),_c('Standard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }